<template>
  <div>
    <!-- 風險告知書 融資者 -->
    <div v-if="type == 1">
      <h2>風險告知書</h2>
      <p>尊敬的用戶：</p>
      <p class="sj">
        在您進行融資之前，請謹慎閱讀本《風險告知書》，仔細了解域名融資可能面臨的風險，並謹慎進行判斷和決定是否進行融資，若您點擊並確認本《風險告知書》意味著您已經知悉了融資所面臨的風險，並做好了承受風險的準備。您在融資中所面臨的風險包括但不限於以下幾個方面：
      </p>
      <p>
        壹、法律、政策風險，因本網站面向全球客戶，本網站業務在您所在國家或地區可能會存在合規風險，屆時可能對您的融資造成不利後果。
      </p>
      <p>
        二、域名價值波動風險，因域名行情是處於波動的狀態，因此域名的價值可能降低，屆時將可能導致域名價值低於融資金額的風險。
      </p>
      <p>
        三、域名特有風險，由於域名的特殊性，用於擔保的域名可能會存在權屬糾紛、使用權瑕疵等導致域名被轉移或者價值降低的風險。
      </p>
      <p>
        四、操作風險，您在業務操作過程中發生差錯，或者委托他人付款可能會存在延遲或者損失的風險。
      </p>
      <p>
        五、處置風險，若您違約，您的域名將會被投資人自行或者委托第三方通過拍賣，議價，壹口價，打包價等方式進行處置，屆時您的域名可能面臨低價處置的風險，若域名處置款不足以清償債務，您仍然需要補足。
      </p>
      <p>
        六、無擔保風險，融資界及HONGKONG PROFIT POWER
        LIMITED不會對融資人的融資做任何形式的保證、擔保，也不會對融資款進行兌付，屆時您可能面臨域名被處置的風險。
      </p>
      <p>
        七、其他風險，即由於其他不可預見或者很難遇見的情形將會給融資帶來損失的風險。
      </p>
      <p class="text-right">HONGKONG PROFIT POWER LIMITED</p>
    </div>
    <!-- 風險告知書 投資者 -->
    <div v-if="type == 2">
      <h2>風險告知書</h2>
      <p>尊敬的投資人：</p>
      <p class="sj">
        在您進行投資之前，請謹慎閱讀本《風險告知書》，仔細了解域名投資可能面臨的風險，並謹慎進行判斷和決定是否進行投資，若您點擊並確認本《風險告知書》意味著您已經知悉了投資所面臨的風險，並做好了承受風險的準備。您在投資中所面臨的風險包括但不限於以下幾個方面：
      </p>
      <p>
        壹、法律、政策風險，因本網站面向全球客戶，本網站業務在您所在國家或地區可能會存在合規風險，屆時可能對您的投資造成不利後果。
      </p>
      <p>
        二、域名價值波動風險，因域名行情是處於波動的狀態，因此域名的價值可能降低，屆時將可能導致域名價值低於融資金額的風險。
      </p>
      <p>
        三、域名特有風險，由於域名的特殊性，用於擔保的域名可能會存在權屬糾紛、使用權瑕疵等導致域名被轉移或者價值降低的風險。
      </p>
      <p>
        四、操作風險，您在業務操作過程中發生差錯，或者委托他人付款可能會存在延遲或者損失的風險。
      </p>
      <p>
        五、信用風險，您投資的對象可能會因為各種原因發生違約，將有可能導致您收不回投資款的風險。
      </p>
      <p>
        六、無擔保風險，融資界及HONGKONG PROFIT POWER
        LIMITED不會對投資人的投資做任何形式的保證、擔保，也不會對投資款進行兌付，屆時可能面臨投資款損失風險。若發生違約，域名壹律通過拍賣、議價、壹口價、打包價等方式進行處置，處置資金不足以支付投資款的，則投資人將發生實質損失。
      </p>
      <p>
        七、其他風險，即由於其他不可預見或者很難遇見的情形將會給投資帶來損失的風險。
      </p>
      <p class="text-right">HONGKONG PROFIT POWER LIMITED</p>
    </div>
    <!-- 域名投資協議 -->
    <div v-if="type == 3">
      <h2>聲明</h2>
      <p>尊敬的用戶：</p>
      <p>
        域名投資系註冊用戶之間的行為，與融資界及其運營公司HONGKONG PROFIT POWER
        LIMITED無關，交易過程由註冊用戶自行完成。對於域名投資款及域名，融資界及其運營公司HONGKONG
        PROFIT POWER LIMITED沒有任何償還義務，也不承擔保證責任和兌付責任。
      </p>
      <p class="text-right">HONGKONG PROFIT POWER LIMITED</p>

      <h2>域名投資協議</h2>

      <p>甲方（域名持有人）：</p>
      <div
        v-if="
          agreeData &&
            agreeData.State != 0 &&
            agreeData.State != 3 &&
            agreeData.State != 4 &&
            agreeData.State != 5
        "
      >
        <table>
          <tr>
            <td :style="{ width: '20%' }">用戶ID</td>
            <td>{{ personMsg.LoanUser.UserId }}</td>
            <td>真實姓名</td>
            <td>{{ personMsg.LoanUser.RealName }}</td>
          </tr>
          <tr>
            <td :style="{ width: '20%' }">身份證號碼</td>
            <td>{{ personMsg.LoanUser.IdCardNumber }}</td>
            <td>註冊郵箱</td>
            <td>{{ personMsg.LoanUser.Email }}</td>
          </tr>
        </table>

        <table :style="{ borderTop: 0 }" width="20%">
          <tr>
            <td :style="{ width: '20%' }">質押域名</td>
            <td class="domain">
              <span v-for="(v, i) in personMsg.LoanPledgeList" :key="i"
                >{{ v.PledgeName }} ，</span
              >
            </td>
          </tr>
        </table>

        <p>乙方（投資人）：</p>
        <table>
          <tr>
            <td>真實姓名</td>
            <td>用戶ID</td>
            <td>投資金額(元)</td>
            <td>投資周期(天)</td>
          </tr>
          <tr v-for="(v, i) in personMsg.InvestmentSchemeList" :key="i">
            <td>{{ v.RealName }}</td>
            <td>{{ v.UserId }}</td>
            <td>{{ v.Amount }}</td>
            <td>{{ v.InvestCycleValue }}</td>
          </tr>
        </table>

        <p>
          甲方、乙方均系融資界知識產權服務平臺（以下簡稱融資界）註冊用戶，甲、乙雙方均
          對域名有比較專業的認識，現就域名投資相關事宜達成如下協議。
        </p>
        <p>
          <b>壹、借款基本信息</b>
        </p>
        <p>
          1.1甲方作為域名的持有人，將托管域名質押乙方，向乙方進行借款，乙方同意對甲方進行投資。
        </p>
        <table>
          <tr>
            <td>項目編號</td>
            <td>{{ agreeData.Number }}</td>
          </tr>
          <tr>
            <td>借款詳細用途</td>
            <td>{{ agreeData.Description }}</td>
          </tr>
          <tr>
            <td>借款本金數額（小寫）</td>
            <td>¥{{ agreeData.Amount }}</td>
          </tr>
          <tr>
            <td>借款本金數額（大寫）</td>
            <td>{{ agreeData.Amount | upmoney }}</td>
          </tr>
          <tr>
            <td>借款年化利率</td>
            <td>{{ $math.eval(`${agreeData.Rate}*100`) }}%</td>
          </tr>
          <tr>
            <td>域名管理費率（域名持有人支付）</td>
            <td>{{ $math.eval(`${agreeData.ManagementFeeRate}*100`) }}%/月</td>
          </tr>
          <tr>
            <td>投資管理費率（投資人支付）</td>
            <td>{{ $math.eval(`${safe.InvestManagementFeeRate}*100`) }}%/月</td>
          </tr>
          <tr>
            <td>月還款額</td>
            <td>詳情見還款計劃 （固定）</td>
          </tr>
          <tr>
            <td>還款日</td>
            <td>詳情見還款計劃 （固定）</td>
          </tr>
          <tr>
            <td>借款到期日</td>
            <td>{{ agreeData.EndAt }}</td>
          </tr>
          <tr>
            <td>協議生效日期</td>
            <td>{{ agreeData.ProtocolAt }}</td>
          </tr>
        </table>

        <p>還款計劃：</p>
        <table>
          <tr>
            <td>期數</td>
            <td>還款日期</td>
            <td>還款金額</td>
            <td>還款類型</td>
          </tr>
          <tr v-for="(v, i) in personMsg.RepaymentPlanList" :key="i">
            <td>{{ v.Phase }}</td>
            <td>{{ v.RepayAt }}</td>
            <td>¥{{ v.RepayAmount }}</td>
            <td>{{ v.IsEndPhase == true ? "本金+利息" : "利息" }}</td>
          </tr>
        </table>
      </div>
      <div v-else>
        <table>
          <tr>
            <td>用戶ID</td>
            <td>（&ID）</td>
            <td>真實姓名</td>
            <td>（&真實姓名）</td>
          </tr>
          <tr>
            <td>身份證號碼</td>
            <td>（&甲方身份證號）</td>
            <td>註冊郵箱</td>
            <td>（&註冊郵箱）</td>
          </tr>
          <tr>
            <td>質押域名</td>
            <td colspan="3">（&抵押的域名，以分號隔開）</td>
          </tr>
        </table>

        <p>乙方（投資人）：</p>
        <table>
          <tr>
            <td>真實姓名</td>
            <td>用戶ID</td>
            <td>投資金額</td>
            <td>投資周期</td>
          </tr>
          <tr>
            <td>（&真實姓名）</td>
            <td>（&ID）</td>
            <td>（&投標金額）</td>
            <td>（&投標周期）</td>
          </tr>
        </table>

        <p>
          甲方、乙方均系融資界知識產權服務平臺（以下簡稱融資界）註冊用戶，甲、乙雙方均
          對域名有比較專業的認識，現就域名投資相關事宜達成如下協議。
        </p>
        <p>
          <b>壹、借款基本信息</b>
        </p>
        <p>
          1.1甲方作為域名的持有人，將托管域名質押乙方，向乙方進行借款，乙方同意對甲方進行投資。
        </p>
        <table>
          <tr>
            <td>項目編號</td>
            <td>（&借款項目編號）</td>
          </tr>
          <tr>
            <td>借款詳細用途</td>
            <td>個人消費（&借款用途）</td>
          </tr>
          <tr>
            <td>借款本金數額（小寫）</td>
            <td>（&融資金額）</td>
          </tr>
          <tr>
            <td>借款本金數額（大寫）</td>
            <td>（&融資金額大寫）</td>
          </tr>
          <tr>
            <td>借款年化利率</td>
            <td>（&年化）</td>
          </tr>
          <!-- <tr>
            <td>管理費率（由域名托管人收取）</td>
            <td>（&年化）</td>
          </tr>-->
          <tr>
            <td>域名管理費率（域名持有人支付）</td>
            <td>（&年化）</td>
          </tr>

          <tr>
            <td>投資管理費率（投資人支付）</td>
            <td>（&年化）</td>
          </tr>
          <tr>
            <td>月還款額</td>
            <td>詳情見還款計劃 （固定）</td>
          </tr>
          <tr>
            <td>還款日</td>
            <td>詳情見還款計劃 （固定）</td>
          </tr>
          <tr>
            <td>借款到期日</td>
            <td>（&借款到期日）</td>
          </tr>
          <tr>
            <td>協議生效日期</td>
            <td>（&放款時間）</td>
          </tr>
        </table>

        <p>還款計劃：</p>
        <table>
          <tr>
            <td>期數</td>
            <td>還款日期</td>
            <td>還款金額</td>
            <td>還款類型</td>
          </tr>
          <tr>
            <td>1</td>
            <td>（&還款日期）</td>
            <td>（&還款金額）</td>
            <td>（&利息）</td>
          </tr>
          <tr>
            <td>2</td>
            <td>（&還款日期）</td>
            <td>（&還款金額）</td>
            <td>（&利息+本金）</td>
          </tr>
        </table>
      </div>
      <p>
        <b>二、協議的訂立、生效</b>
      </p>
      <p>
        2.1甲、乙雙方通過網絡點擊的方式在線訂立《域名投資協議》，投資人點擊確認《域名投資協議》後，合同成立，乙方在平臺釋放投資款後，合同生效。
      </p>
      <p>
        2.2《域名投資協議》在甲方及乙方之間發生法律效力，合同生效後，融資界其他註冊用戶可以通過直接代甲方償還乙方投資款的方式取得乙方投資人資格，屆時原乙方投資人退出協議，新乙方投資人加入，《域名投資協議》在甲方及新乙方投資人之間繼續生效。
      </p>
      <p>
        <b>三、域名托管</b>
      </p>
      <p>
        3.1乙方指定第三方域名服務商（簡稱域名托管人）代乙方接收甲方質押的域名，域名托管人為甲、乙雙方提供收取、保管、轉移、處置域名服務（以下簡稱域名托管服務）。
      </p>
      <p>
        3.2甲、乙雙方授權並確定由融資界負責通知域名托管人提供收取、保管、轉移、處置域名服務。
      </p>
      <p>
        3.3本協議生效後，甲方應當按時向域名托管人支付域名管理費。甲方可以向域名托管人預存域名管理費，域名托管人優先扣除預存的域名管理費。若甲方未按時結清借款或域名管理費，甲方無權要求域名托管人返還質押域名。域名托管期間由甲方負責續費。
      </p>
      <p>
        <b>四、承諾及保證</b>
      </p>
      <p>
        4.1甲、乙雙方承諾融資界及域名托管人對借款不承擔任何風險，也不需要對借款承擔保證責任、兌付責任，甲、乙雙方域名投資權利義務與融資界無關。融資界網頁上所有的數據均為註冊用戶發布，僅供甲、乙雙方進行參考，風險由甲、乙雙方自行承擔。
      </p>
      <p>
        4.2甲、乙雙方承諾，對本協議涉及的所有款項包括本金、利息、管理費等項目的數額由各方自行核算，若發生糾紛的，以融資界記錄到的數據為準。
      </p>
      <p>4.3甲方承諾按還款計劃償還投資款本金利息及域名管理費。</p>
      <p>
        4.4甲方承諾其是質押域名的所有權人，對質押域名有完全的處置權利，質押域名不存在任何被盜、贓物、權屬、擔保、使用權糾紛或其他任何影響域名價值金和權利的情形，也不侵犯他人合法權益。域名托管期間若因域名本身發生糾紛，由甲方承擔全部責任。
      </p>
      <p>
        4.5甲方承諾按約定用途使用資金，不得使用用戶投資款從事任何違法犯罪活動。
      </p>
      <p>
        4.6乙方確認資金來源合法，並為其合法所有，乙方不存賭博、洗錢、掩飾隱瞞犯罪所得、贓款等違法犯罪情形，也不得吸收他人的資金用於投資。
      </p>
      <p>
        <b>五、付款及還款</b>
      </p>
      <p>5.1乙方指定賬戶向甲方付款，甲方應當使用自己名下的銀行賬戶用於收款。</p>
      <p>
        5.2還款時甲方應當向乙方指定銀行賬戶償還款項，因指定收款賬戶發生爭議的責任由乙方自行承擔。域名管理費由甲方直接向域名托管人支付，甲方預付費的，由域名托管人自行扣除。
      </p>
      <p>
        5.3甲方應當按照還款計劃還款，還款日不受節假日的影響，還款當日24:00時之前必須還款。
      </p>
      <p>
        <b>六、逾期還款</b>
      </p>
      <p>
        6.1若甲方逾期還款，除按還款計劃支付本金及利息外，還應當額外每日按照本息的萬分之六的標準向乙方支付罰金。
      </p>
      <p>
        6.2若甲方逾期還款，融資界有權通知域名托管人處置域名，域名托管人可以自行或者委托第三方通過議價、壹口價、打包價、拍賣方式或其他方式處置域名，域名處置所產生的手續費及其他費用由甲方承擔，優先在處置域名所得款項中扣除。
      </p>
      <p>
        6.3甲、乙雙方知悉域名屬於知識產權、無形資產，並了解域名的特殊性，明白處置域名存在的各種風險，因此甲、乙雙方認可域名托管人通過議價、壹口價、打包價、拍賣方式或其他方式處置域名過程之中的壹切行為並認可處置域名的結果，尤其可能出現處置域名所得的資金不足以償還全部借款借款的情形，甲、乙雙方仍然認可並承諾不會因為域名處置而追究融資界、域名托管人的任何責任。
      </p>
      <p>
        <b>七、域名處置資金</b>
      </p>
      <p>7.1質押域名處置完後，在質押域名僅用於擔保本協議借款情況下：</p>
      <p>
        7.1.1若處置域名所得款項償還借款後還有剩余資金，則域名托管人應將剩余資金返還給甲方；
      </p>
      <p>
        7.1.2若處置域名所得款項不足以清償本協議借款，則甲方應當繼續承擔清償責任，直至借款還清為止。
      </p>
      <p>7.2質押域名處置完後，在質押域名在融資界用於擔保多筆借款情況下：</p>
      <p>
        7.2.1若處置域名所得款項可以償還全部借款後還有剩余資金，則域名托管人應將剩余資金返還給甲方；
      </p>
      <p>
        7.2.2若處置域名所得款項不能償還完所有借款，則處置域名所得款項應當按照每筆借款使用的授信比例清償。未足額得到清償部分借款，甲方應當繼續承擔還款責任，直至全部借款還清為止。
      </p>
      <p>
        7.3質押域名處置完後，若處置域名所得款項償還已到期的借款之後還有剩余資金，但甲方在融資界還有其他未到期的借款需要償還，則甲方同意將剩余資金作為質押托管在域名托管人用於擔保未到期的借款的償還。
      </p>
      <p>
        7.4若處置域名所得款項不能償還完借款，但甲方在融資界還有其他域名及款項的，則可以直接處置甲方的其他域名以及款項用於還款。
      </p>
      <p>
        <b>八、通知與送達</b>
      </p>
      <p>
        8.1協議各方因履行本協議而相互發出或者提供的所有通知、文件、資料，均以本協議所列明及在融資界留下的聯系地址、電話、郵箱、微信、QQ等聯系方式進行送達，可由采用專人送達、掛號郵遞、特快專遞或通過融資界發布等方式傳送，壹方如果變更聯系方式，應當書面通知融資界，電子信息或者郵件壹經發出即視為送達。
      </p>
      <p>
        <b>九、管轄及法律適用</b>
      </p>
      <p>
        9.1本協議的成立、生效、履行、解釋及糾紛解決，適用仲裁機構所在地區法律。
      </p>
      <p>
        9.2若用戶和融資界之間發生任何糾紛或爭議無法自行解決的，應向深圳仲裁委員會申請仲裁，仲裁流程及規則以申請時的流程及規則為準。
      </p>
    </div>
    <!-- 用戶服務協議 -->
    <div v-if="type == 4">
      <h2>閱讀提示</h2>
      <p>尊敬的用戶：</p>
      <p>
        融資界知識產權服務平臺（以下簡稱融資界）系由HONGKONG PROFIT POWER
        LIMITED建立並運營，旨在打造全球化的知識產權服務機構，並為融資界的註冊用戶提供完善的知識產權服務。請您在註冊用戶時，謹慎閱讀《用戶服務協議》，當您通過在線點擊的方式確認並同意《用戶服務協議》，壹旦點擊確認即代表您接受協議的全部條款。
      </p>
      <p>
        融資界特別提示您註意《用戶服務協議》中有關風險、免責、權利限制、糾紛管轄條款，若您不接受這些條款，請您不要註冊成為融資界的用戶。
      </p>
      <p class="text-right">HONGKONG PROFIT POWER LIMITED</p>
      <h2>用戶服務協議</h2>
      <h3>第壹部分 協議的訂立、生效、修改</h3>
      <p>
        1.1《用戶服務協議》通過網絡點擊確認的方式在線訂立，用戶在註冊時通過點擊按鈕確認並同意《用戶服務協議》後生效。
      </p>
      <p>
        1.2《用戶服務協議》在用戶及HONGKONG PROFIT POWER
        LIMITED之間發生法律效力。
      </p>
      <p>
        1.3若用戶未點擊《用戶服務協議》，但實際上使用了融資界提供的相應功能或服務時，本協議仍然生效。
      </p>
      <p>
        1.4用戶使用融資界相應服務除了應當遵守《用戶服務協議》，還應當遵守融資界為相應服務而專門發布的協議、規定等規則。用戶未經註冊但是用了融資界的相關服務功能的，除了應當遵守相應服務而專門發布的協議、規定等規則，也應當遵守《用戶服務協議》。
      </p>
      <p>
        1.5融資界有權修改《用戶服務協議》，更新後的協議壹經發布即發生即生效，用戶有義務在使用融資界時查詢最新的《用戶服務協議》，並承諾遵守修改後的《用戶服務協議》。
      </p>
      <h3>第二部分 用戶的權利及義務</h3>
      <p>
        2.1用戶可以是自然人、法人或其他組織，用戶應當具有完全的民事權利能力和行為能力（公民的民事權利能力及行為能力以其所在國或地區為準），禁止無完全民事權利能力和行為能力的用戶註冊並使用融資界的任何服務。
      </p>
      <p>
        2.2用戶應當按照融資界的要求填寫真實的姓名、身份證件號碼、聯系地址、聯系方式等信息，具體以融資界註冊頁面要求為準。用戶應當妥善保管用戶名、密碼、密保、郵箱等與安全相關的信息，防止該信息被他人盜取。用戶使用用戶名登陸後的所有操作，全部視為用戶本人的操作，由用戶承擔全部責任。
      </p>
      <p>
        2.3用戶註冊成功後可以在融資界瀏覽或發布與域名、著作權、商標權、專利權等知識產權相關的信息，如知識產權的權利歸屬、價值大小、簡介、權利來源、持有人信息、轉讓價格、交易方式等信息，註冊用戶承諾所發布的信息是真是有效的，且不遺漏應當告知其他用戶的情形。融資界服務及功能僅提供給註冊用戶使用，用戶註冊成功後才可以使用，用戶可以使用的服務及功能以融資界實際公布為準。
      </p>
      <p>
        2.4禁止用戶發布虛假信息或侵犯他人的合法權益的信息，未經知識產權權利人的許可不得發布不屬於用戶的知識產權的信息。
      </p>
      <p>
        2.5若用戶使用融資界的服務及功能涉及資金的，提供資金的用戶應當承諾資金來源是正當的、合法的，不是違法犯罪所得，也不涉及洗錢和吸收他人存款的情形，收取資金的用戶應當承諾正當的、合法的使用該資金。註冊用戶之間從事知識產權交易的，可以通過自行或委托他人的方式進行交易。涉及資金的劃轉、知識產權的交付的，由用戶自行完成或者委托其他第三方服務機構完成，融資界不參與註冊用戶的融資活動。用戶可以指定銀行賬戶用於交易雙方之間的資金劃轉，指定賬戶應當符合所在國家或地區的法律或政策。
      </p>
      <p>
        2.6用戶發布或使用融資界的相關功能應當符合所在國家或地區的法律規定，不得從事用戶所在國家或地區禁止開展的服務。
      </p>
      <h3>第三部分 融資界的權利及義務</h3>
      <p>
        3.1融資界以使用服務當時的狀態為用戶提供知識產權服務，允許註冊用戶在融資界發布相應的知識產權信息，並從事與知識產權相關的業務。融資界在現有技術上對網站各個模塊及功能板塊進行維護，並努力改進相關技術，完善在線註冊或信息發布等功能，但融資界不承諾壹定能夠滿足或實現用戶所需要的功能。
      </p>
      <p>
        3.2若融資界發現用戶發布的信息或開展的業務存在異常，融資界有權不通知用戶即暫停或中止用戶的相關操作，並有權采取壹切措施，包括但不限於限制用戶功能，撤銷用戶操作，交易回滾等，直至異常情形消除，恢復至正常狀態。用戶的操作是否屬於異常，由融資界認定，因業務異常導致的損失，由用戶自行承擔。
      </p>
      <p>
        3.3若註冊用戶之間發生糾紛，註冊用戶可以申請融資界進行處理，融資界同意為雙方處理糾紛的，可以自行或者委托第三方進行調查處理，由此產生費用的，全部由註冊用戶承擔，涉及第三方機構的收費服務項目的，註冊用戶應當直接向第三方機構支付。註冊用戶之間發生對資金項目發生爭議的，以融資界記錄到的數據為準。
      </p>
      <p>
        3.4融資界不對註冊用戶之間的任何交易承擔任何責任，不會為用戶的資金提供擔保，壹切註冊用戶間的交易由註冊用戶自行承擔責任，融資界不承諾的事項包括但不限於以下情形：
        <br />（1）融資界不承諾用戶之間的交易壹定能夠完成或交易目的壹定能夠實現；
        <br />（2）融資界不承諾用戶出借的資金壹定能夠收回；
        <br />（3）不承諾用戶或第三方機構交易或處置知識產權不會造成損失；
        <br />（4）不承諾交易知識產權的權屬是完整的或沒有使用限制；
        <br />（5）其他與融資界無關的事項。
      </p>
      <h3>第四部分 風險提示</h3>
      <p>
        4.1用戶確認：融資界上的信息均為融資界註冊用戶發布的信息，融資界對註冊用戶發布的信息的真實性不承擔責任，信息的真實性由註冊用戶自行分辨。
      </p>
      <p>
        4.2用戶確認：融資界上的知識產權交易均由融資界註冊用戶發起，註冊用戶擬交易的知識產權可能會存在瑕疵，如權屬瑕疵，擔保瑕疵或使用瑕疵等。
      </p>
      <p>
        4.3用戶確認：若用戶以知識產權作為質押發起借款交易，則存在還款不能時，知識產權被低價處置的風險，以及出借的資金可能會發生損失的風險。
      </p>
      <p>
        4.4用戶確認：若用戶所在國家或地區禁止用戶從事知識產權交易，則用戶之間的交易存在被認定為無效的可能。
      </p>
      <p>
        4.5用戶確認：因用戶之間的交易涉及不同國家法律政策的，則在不同的國家法律政策不盡相同，用戶可能會面臨所在國家或地區的法律政策風險。
      </p>
      <h4>第五部分 服務費用</h4>
      <p>
        5.1用戶在融資界瀏覽、發布知識產權信息，使用融資界提供的功能，融資界不收取費用。
      </p>
      <p>
        5.2用戶之間自行發起並完成知識產權交易的，用戶不需要支付費用。若用戶選取第三方機構提供知識產權價值評估、知識產權托管、委托辦理知識產權過戶手續、委托出售知識產權、知識產權拍賣、知識產權經紀交易等服務的，由提供服務的第三方機構收取相關費用。
      </p>
      <p>
        5.3第三方服務機構的收費標準，由第三方服務機構決定，用戶選擇第三方服務機構的，應當直接向第三方服務機構支付相關費用。收費標準發生變更的，以發生交易時的收費標準為準。
      </p>
      <h3>第六部分 不可抗力及免責</h3>
      <p>
        6.1因無法預見或不能克服的法律、技術以及其他風險，包括但不限於因不可抗力、病毒、木馬、黑客攻擊、系統不穩定、第三方服務瑕疵、政府行為等原因導致的服務中斷、數據丟失或其他損失的，融資界不承擔責任。
      </p>
      <p>
        6.2即使融資界提供的服務存在瑕疵，但瑕疵是當時技術水平所無法避免的，由此給用戶造成的數據或信息丟失等損失的，融資界不承擔任何責任。
      </p>
      <h3>第七部分 融資界知識產權聲明</h3>
      <p>
        7.1
        融資界提供的內容（包括但不限於網頁、文字、圖片、音頻、視頻、圖表等）及融資界提供服務時所依托的域名、網站、軟件的著作權、商標權、專利權及其他知識產權均歸PROFIT
        POWER LIMITED所有。
      </p>
      <h3>第八部分 通知與送達</h3>
      <p>
        8.1協議各方因履行本協議而相互發出或者提供的所有通知、文件、資料，均以本協議所列明及在融資界留下的聯系地址、電話、郵箱、微信、QQ等聯系方式進行送達，可由采用專人送達、掛號郵遞、特快專遞或通過融資界發布等方式傳送，壹方如果變更聯系方式，應當書面通知融資界，電子信息或者郵件壹經發出即視為送達。
      </p>
      <h3>第九部分 管轄及法律適用</h3>
      <p>9.1本協議的成立、生效、履行、解釋及糾紛解決，適用香港地區法律。</p>
      <p>
        9.2若用戶和融資界之間發生任何糾紛或爭議無法自行解決的，應向Hong Kong
        International Arbitration
        Centre（HKIAC）申請仲裁，仲裁流程及規則以申請時的流程及規則為準。
      </p>
    </div>
    <!-- 隱私保護協議 -->
    <div v-if="type == 5">
      <h2>隱私保護規則</h2>
      <p>
        第壹條
        為更好的保護用戶的隱私，保護用戶的知識產權信息，以及更好的為客戶提供服務，制定本規則。
      </p>
      <p>
        第二條
        本規則適用於融資界所有服務，但不適用於其他第三方向用戶提供的服務。
      </p>
      <p>
        第三條
        融資界應當以具體的、清晰的和正當的目的，以及合法、合理、透明的方式處理用戶信息數據。
      </p>
      <p>
        第四條
        用戶數據應當保持準確性，對不準確的信息，用戶有權更正和擦除，處理用戶數據應當在必要的限度之內。
      </p>
      <p>
        第五條
        融資界有權要求自然人用戶提供姓名、性別、身份證號碼、身份證復印件、護照、聯系電話、郵箱，地址、銀行賬號、開戶行、賬戶名等與用戶身份信息、聯系信息、財務信息相關的信息。
      </p>
      <p>
        第六條
        融資界有權要求法人或其他組織提供單位名稱、註冊地址、營業執照、法定代表人身份證明、註冊地址、聯系電話、郵箱、銀行賬號、開戶行、賬戶名等與法人或其他組織註冊信息、聯系信息、財務信息相關的信息。
      </p>
      <p>
        第七條
        若因融資界業務模式的變更，需要用戶合理的提供其他信息的，由融資界將需要提供的信息公示在融資界網站上，供用戶填寫，新增的用戶信息，將按照本規則被平等的處理和保護。
      </p>
      <p>
        第八條 用戶在使用服務的同時，融資界會收集以下信息：
        <br />（1）設備信息：如設備型號、操作系統版本、設備設置、唯壹設備標識符等軟硬件特征信息）、設備所在位置相關信息（例如IP地址、GPS位置以及能夠提供相關信息的Wi-Fi接入點、藍牙和基站等傳感器信息）。
        <br />（2）日誌信息：當用戶使用網站提供的服務時，融資界會自動收集用戶對融資界服務的詳細使用情況，作為有關網絡日誌保存。例如用戶的搜索查詢內容、IP地址、瀏覽器的類型、電信運營商、使用的語言、訪問日期和時間及用戶訪問的網頁記錄等。
        <br />（3）用戶賬戶的支持信息：基於用戶使用融資界服務而產生的用戶的咨詢記錄、報障記錄和針對用戶故障的排障過程（如通信或通話記錄），融資界將通過記錄、分析這些信息以便更及時響應用戶的幫助請求，以及用於改進服務。
        <br />（4）歷史服務信息：例如用戶曾使用過的服務的類型、瀏覽過的內容、使用過的功能、歷史的交易數據、歷史信用信息數據、歷史交易數據、歷史授權數據、知識產權權屬信息、歷史變動信息等。
      </p>
      <p>
        第八條 融資界可能出於如下目的，使用用戶提交或融資界收集的用戶信息：
        <br />（1）為了向用戶提供，維護、改進服務；
        <br />（2）有權部門或利害關系人要求提供信息；
        <br />（3）按照知識產權相關主管部門的要求提供信息；
        <br />（4）其他合理目的。
      </p>
      <p>
        第九條
        融資界不會跟第三方機構以共享、轉讓、授權、公開披露等方式使用用戶數據，除非用戶本人許可或應有關部門的要求或有合理的理由以該等方式使用用戶數據。
      </p>
      <p>
        第十條
        用戶可以登錄網站後臺查詢、管理、並更使用融資界服務時而提交的基本業務信息（基本資料）和聯系人信息，維持業務必要的數據除外。
      </p>
      <p>
        第十壹條
        融資界盡可能努力采取各種合理的物理、電子和管理方面的安全措施來保護用戶信息。防止用戶信息遭到未經授權訪問、公開披露、使用、修改、損壞或丟失。
      </p>
      <p class="text-right">HONGKONG PROFIT POWER LIMITED</p>
    </div>
    <!-- 域名價值估算聲明 -->
    <div v-if="type == 6">
      <h2>域名價值估算聲明</h2>
      <p>尊敬的用戶：</p>
      <p class="sj">
        融資界應註冊用戶申請對域名價值進行估算，估算的結果僅供用戶進行參考，壹經估算，註冊用戶不得高於融資界估算的價值發布借款。若因為域名行情發生變化，則域名的估算價值可能會被調高或者調低。若用戶在估算的價值範圍內質押域名發布借款，也仍然存在著不被其他註冊用戶認可的可能性。
      </p>
      <p class="sj">
        用戶點擊確認本聲明，代表用戶同意、認可域名估算結果僅供註冊用戶進行參考，且融資界不對域名價值估算承擔責任，估算價值是否合理，由用戶自行判斷並承擔域名估值可能不準確所帶來的風險。
      </p>
      <p>特此聲明。</p>
      <p class="text-right">HONGKONG PROFIT POWER LIMITED</p>
    </div>
    <!-- 域名信用周轉協議 -->
    <div v-if="type == 7">
      <h2>聲明</h2>
      <p>尊敬的用戶：</p>
      <p>
        域名投資系註冊用戶之間的行為，與融資界及其運營公司HONGKONG PROFIT POWER
        LIMITED無關，交易過程由註冊用戶自行完成。對於域名投資款及域名，融資界及其運營公司HONGKONG
        PROFIT POWER LIMITED沒有任何償還義務，也不承擔保證責任和兌付責任。
      </p>
      <p class="text-right">HONGKONG PROFIT POWER LIMITED</p>

      <h2>域名信用周轉協議</h2>

      <p>甲方（域名持有人）：</p>
      <div
        v-if="
          agreeData &&
            agreeData.State != 0 &&
            agreeData.State != 3 &&
            agreeData.State != 4 &&
            agreeData.State != 5
        "
      >
        <table>
          <tr>
            <td :style="{ width: '20%' }">用戶ID</td>
            <td>{{ personMsg.LoanUser.UserId }}</td>
            <td>真實姓名</td>
            <td>{{ personMsg.LoanUser.RealName }}</td>
          </tr>
          <tr>
            <td :style="{ width: '20%' }">身份證號碼</td>
            <td>{{ personMsg.LoanUser.IdCardNumber }}</td>
            <td>註冊郵箱</td>
            <td>{{ personMsg.LoanUser.Email }}</td>
          </tr>
        </table>

        <table :style="{ borderTop: 0 }" width="20%">
          <tr>
            <td :style="{ width: '20%' }">質押域名</td>
            <td colspan="3">（&本信用周轉借款無質押域名）</td>
          </tr>
        </table>

        <p>乙方（投資人）：</p>
        <table>
          <tr>
            <td>真實姓名</td>
            <td>用戶ID</td>
            <td>投資金額(元)</td>
            <td>投資周期(天)</td>
          </tr>
          <tr v-for="(v, i) in personMsg.InvestmentSchemeList" :key="i">
            <td>{{ v.RealName }}</td>
            <td>{{ v.UserId }}</td>
            <td>{{ v.Amount }}</td>
            <td>{{ v.InvestCycleValue }}</td>
          </tr>
        </table>

        <p>
          甲方、乙方均系融資界知識產權服務平臺（以下簡稱融資界）註冊用戶，甲、乙雙方均
          對域名有比較專業的認識，現就域名投資相關事宜達成如下協議。
        </p>
        <p>
          <b>壹、借款基本信息</b>
        </p>
        <p>
          1.1甲方作為域名的持有人，將托管域名質押乙方，向乙方進行借款，乙方同意對甲方進行投資。
        </p>
        <table>
          <tr>
            <td>項目編號</td>
            <td>{{ agreeData.Number }}</td>
          </tr>
          <tr>
            <td>借款詳細用途</td>
            <td>{{ agreeData.Description }}</td>
          </tr>
          <tr>
            <td>借款本金數額（小寫）</td>
            <td>¥{{ agreeData.Amount }}</td>
          </tr>
          <tr>
            <td>借款本金數額（大寫）</td>
            <td>{{ agreeData.Amount | upmoney }}</td>
          </tr>
          <tr>
            <td>借款年化利率</td>
            <td>{{ $math.eval(`${agreeData.Rate}*100`) }}%</td>
          </tr>
          <!-- <tr>
            <td>管理費率（由域名托管人收取）</td>
            <td>{{$math.eval(`${agreeData.ManagementFeeRate}*100`)}}%</td>
          </tr>-->
          <tr>
            <td>域名管理費率（域名持有人支付）</td>
            <td>{{ $math.eval(`${agreeData.ManagementFeeRate}*100`) }}%/月</td>
          </tr>
          <!-- <tr>
            <td>投資管理費率（投資人支付）</td>
            <td>{{$math.eval(`${safe.InvestManagementFeeRate}*100`)}}%/月</td>
          </tr>-->
          <tr>
            <td>月還款額</td>
            <td>詳情見還款計劃 （固定）</td>
          </tr>
          <tr>
            <td>還款日</td>
            <td>詳情見還款計劃 （固定）</td>
          </tr>
          <tr>
            <td>借款到期日</td>
            <td>{{ agreeData.EndAt }}</td>
          </tr>
          <tr>
            <td>協議生效日期</td>
            <td>{{ agreeData.ProtocolAt }}</td>
          </tr>
        </table>

        <p>還款計劃：</p>
        <table>
          <tr>
            <td>期數</td>
            <td>還款日期</td>
            <td>還款金額</td>
            <td>還款類型</td>
          </tr>
          <tr v-for="(v, i) in personMsg.RepaymentPlanList" :key="i">
            <td>{{ v.Phase }}</td>
            <td>{{ v.RepayAt }}</td>
            <td>¥{{ v.RepayAmount }}</td>
            <td>{{ v.IsEndPhase == true ? "本金+利息" : "利息" }}</td>
          </tr>
        </table>
      </div>
      <div v-else>
        <table>
          <tr>
            <td>用戶ID</td>
            <td>（&ID）</td>
            <td>真實姓名</td>
            <td>（&真實姓名）</td>
          </tr>
          <tr>
            <td>身份證號碼</td>
            <td>（&甲方身份證號）</td>
            <td>註冊郵箱</td>
            <td>（&註冊郵箱）</td>
          </tr>
          <tr>
            <td>質押域名</td>
            <td colspan="3">（&本信用周轉借款無質押域名）</td>
          </tr>
        </table>

        <p>乙方（投資人）：</p>
        <table>
          <tr>
            <td>真實姓名</td>
            <td>用戶ID</td>
            <td>投資金額</td>
            <td>投資周期</td>
          </tr>
          <tr>
            <td>（&真實姓名）</td>
            <td>（&ID）</td>
            <td>（&投標金額）</td>
            <td>（&投標周期）</td>
          </tr>
        </table>

        <p>
          甲方、乙方均系融資界知識產權服務平臺（以下簡稱融資界）註冊用戶，甲、乙雙方均
          對域名有比較專業的認識，現就域名投資相關事宜達成如下協議。
        </p>
        <p>
          <b>壹、借款基本信息</b>
        </p>
        <p>1.1甲方向乙方進行借款，乙方同意對甲方進行投資。</p>
        <table>
          <tr>
            <td>項目編號</td>
            <td>（&借款項目編號）</td>
          </tr>
          <tr>
            <td>借款詳細用途</td>
            <td>信用周轉</td>
          </tr>
          <tr>
            <td>借款本金數額（小寫）</td>
            <td>（&融資金額）</td>
          </tr>
          <tr>
            <td>借款本金數額（大寫）</td>
            <td>（&融資金額大寫）</td>
          </tr>
          <tr>
            <td>借款年化利率</td>
            <td>（&年化）</td>
          </tr>
          <tr>
            <td>管理費</td>
            <td>（&年化）</td>
          </tr>
          <tr>
            <td>月還款額</td>
            <td>詳情見還款計劃 （固定）</td>
          </tr>
          <tr>
            <td>還款日</td>
            <td>詳情見還款計劃 （固定）</td>
          </tr>
          <tr>
            <td>借款到期日</td>
            <td>（&借款到期日）</td>
          </tr>
          <tr>
            <td>協議生效日期</td>
            <td>（&放款時間）</td>
          </tr>
        </table>

        <p>還款計劃：</p>
        <table>
          <tr>
            <td>期數</td>
            <td>還款日期</td>
            <td>還款金額</td>
            <td>還款類型</td>
          </tr>
          <tr>
            <td>1</td>
            <td>（&還款日期）</td>
            <td>（&還款金額）</td>
            <td>（&利息）</td>
          </tr>
          <tr>
            <td>2</td>
            <td>（&還款日期）</td>
            <td>（&還款金額）</td>
            <td>（&利息+本金）</td>
          </tr>
        </table>
      </div>
      <p>
        <b>二、協議的訂立、生效</b>
      </p>
      <p>
        2.1甲、乙雙方通過網絡點擊的方式在線訂立《域名信用周轉協議》，投資人點擊確認《域名信用周轉協議》後，合同成立，乙方在平臺釋放投資款後，合同生效。
      </p>
      <p>
        2.2《域名信用周轉協議》在甲方及乙方之間發生法律效力，合同生效後，融資界其他註冊用戶可以通過直接代甲方償還乙方投資款的方式取得乙方投資人資格，屆時原乙方投資人退出協議，新乙方投資人加入，《域名信用周轉協議》在甲方及新乙方投資人之間繼續生效。
      </p>
      <p>
        <b>三、域名</b>
      </p>
      <p>
        3.1
        本協議簽訂時，甲方並未質押域名，本借款為信用借款，甲方借到的款項，僅用於償還融資界平臺借款，不得用於提現，也不得作其他用途。
      </p>
      <p>
        3.2乙方指定第三方域名服務商（簡稱域名服務商）為甲、乙雙方提供域名處置服務。
      </p>
      <p>3.3甲、乙雙方授權並確定由融資界負責通知域名服務商提供域名處置服務。</p>
      <p>
        3.4本協議生效後，甲方應當按時向域名服務商支付域名管理費。甲方可以向域名服務商預存域名管理費，域名服務商優先扣除預存的域名管理費。若甲方未按時結清借款或域名管理費，甲方無權要求域名服務商返還域名。
      </p>
      <p>
        <b>四、承諾及保證</b>
      </p>
      <p>
        4.1甲、乙雙方承諾融資界及域名服務商對借款不承擔任何風險，也不需要對借款承擔保證責任、兌付責任，甲、乙雙方域名投資權利義務與融資界無關。融資界網頁上所有的數據均為註冊用戶發布，僅供甲、乙雙方進行參考，風險由甲、乙雙方自行承擔。
      </p>
      <p>
        4.2甲、乙雙方承諾，對本協議涉及的所有款項包括本金、利息、管理費等項目的數額由各方自行核算，若發生糾紛的，以融資界記錄到的數據為準。
      </p>
      <p>4.3甲方承諾按還款計劃償還投資款本金利息及域名管理費。</p>
      <p>
        4.4甲方承諾其在融資界提交的域名是其所有，且對域名有完全的處置權利，域名不存在任何被盜、贓物、權屬、擔保、使用權糾紛或其他任何影響域名價值金和權利的情形，也不侵犯他人合法權益。
      </p>
      <p>
        4.5甲方承諾按約定用途使用資金，不得使用用戶投資款從事任何違法犯罪活動。
      </p>
      <p>
        4.6乙方確認資金來源合法，並為其合法所有，乙方不存賭博、洗錢、掩飾隱瞞犯罪所得、贓款等違法犯罪情形，也不得吸收他人的資金用於投資。
      </p>
      <p>
        <b>五、付款及還款</b>
      </p>
      <p>
        5.1甲方在融資界平臺賬戶收到款，視為甲方收到款，本借款僅用於償還甲方融資界其他借款。
      </p>
      <p>
        5.2還款時甲方應當向乙方指定銀行賬戶償還款項，因指定收款賬戶發生爭議的責任由乙方自行承擔。
      </p>
      <p>
        5.3甲方應當按照還款計劃還款，還款日不受節假日的影響，還款當日24:00時之前必須還款。
      </p>
      <p>
        <b>六、逾期還款</b>
      </p>
      <p>
        6.1若甲方逾期還款，除按還款計劃支付利息外，還應當額外按照每日萬分之五的標準向乙方支付罰息。
      </p>
      <p>
        6.2若甲方逾期還款，融資界有權通知域名服務商處置甲方在融資界的域名，域名服務商可以自行或者委托第三方通過議價、壹口價、打包價、拍賣方式或其他方式處置域名，域名處置所產生的手續費及其他費用由甲方承擔，優先在處置域名所得款項中扣除。
      </p>
      <p>
        6.3甲、乙雙方知悉域名屬於知識產權、無形資產，並了解域名的特殊性，明白處置域名存在的各種風險，因此甲、乙雙方認可域名服務商通過議價、壹口價、打包價、拍賣方式或其他方式處置域名過程之中的壹切行為並認可處置域名的結果，尤其可能出現處置域名所得的資金不足以償還全部借款借款的情形，甲、乙雙方仍然認可並承諾不會因為域名處置而追究融資界、域名服務商的任何責任。
      </p>
      <p>
        <b>七、域名處置資金</b>
      </p>
      <p>7.1域名處置完後：</p>
      <p>
        7.1.1若處置域名所得款項償還借款後還有剩余資金，則域名服務商應將剩余資金返還給甲方；
      </p>
      <p>
        7.1.2若處置域名所得款項不足以清償本協議借款，則甲方應當繼續承擔清償責任，直至借款還清為止。
      </p>
      <p>7.2域名處置完後，在域名在融資界用於擔保多筆借款情況下：</p>
      <p>
        7.2.1若處置域名所得款項可以償還全部借款後還有剩余資金，則域名服務商應將剩余資金返還給甲方；
      </p>
      <p>
        7.2.2若處置域名所得款項不能償還完所有借款，則處置域名所得款項應當按照本融資界借款協議約定的到期日的先後清償借款，同壹天到期的借款，按照比例清償。未足額得到清償部分借款，甲方應當繼續承擔還款責任，直至全部借款還清為止。
      </p>
      <p>
        7.3
        域名處置完後，若處置域名所得款項償還已到期的借款之後還有剩余資金，但甲方在融資界還有其他未到期的借款需要償還，則甲方同意將剩余資金作為質押托管在域名服務商用於擔保未到期的借款的償還。
      </p>
      <p>
        <b>八、通知與送達</b>
      </p>
      <p>
        8.1協議各方因履行本協議而相互發出或者提供的所有通知、文件、資料，均以本協議所列明及在融資界留下的聯系地址、電話、郵箱、微信、QQ等聯系方式進行送達，可由采用專人送達、掛號郵遞、特快專遞或通過融資界發布等方式傳送，壹方如果變更聯系方式，應當書面通知融資界，電子信息或者郵件壹經發出即視為送達。
      </p>
      <p>
        <b>九、管轄及法律適用</b>
      </p>
      <p>
        9.1本協議的成立、生效、履行、解釋及糾紛解決，適用仲裁機構所在地區法律。
      </p>
      <p>
        9.2若用戶和融資界之間發生任何糾紛或爭議無法自行解決的，應向深圳仲裁委員會申請仲裁，仲裁流程及規則以申請時的流程及規則為準。
      </p>
    </div>
    <!-- 域名托管协议 -->
    <div v-if="type == 8">
      <h2>域名托管協議</h2>
      <p>甲方：域名持有人（詳見域名投資協議甲方）</p>
      <p>乙方：投資人（詳見域名投資協議乙方）</p>
      <p>丙方：域名托管人</p>
      <p>
        丙方是第三方知識產權服務機構，現就知識產權托管相關事宜達成如下協議。
      </p>
      <p>
        <b>一、托管域名</b>
      </p>
      <p>
        1、甲方為域名持有人，甲方為了向乙方融資，甲方自願將域名（詳見域名投資協議）質押給乙方。
      </p>
      <p>
        2、乙方指定丙方作為域名托管人，代乙方接收甲方質押的域名，丙方可以使用自己名下的域名賬戶或指定其他人名下的域名賬戶用來接收甲方質押的域名。
      </p>
      <p>3、丙方收到甲方質押的域名視為乙方收到甲方質押的域名。</p>
      <p>
        <b>二、服務內容</b>
      </p>
      <p>
        1、丙方作為域名托管人代為保管甲方的質押域名，並為甲、乙雙方提供如下域名托管服務：
        <br />（1）代乙方收取、保管質押域名。
        <br />（2）代甲、乙雙方push或轉移域名。
        <br />（3）若甲方借款發生違約，代甲、乙雙方處置域名服務，並支付處置域名的資金。
        <br />（4）其他與域名相關的服務。
      </p>
      <p>
        2、甲、乙雙方授權並確定由融資界負責按照甲、乙雙方的約定和融資界的規則通知丙方提供域名托管服務。
      </p>
      <p>
        <b>三、服務費用</b>
      </p>
      <p>
        1、甲方應當按時向提供域名托管服務的丙方支付域名管理費，管理費的標準以域名投資協議約定的為準，域名投資協議生效即開始計算管理費。
      </p>
      <p>2、甲方可以向丙方預存管理費，丙方優先扣除預存的管理費。</p>
      <p>3、若甲方未按時結清借款或管理費，甲方無權要求丙方返還質押域名。</p>
      <p>4、域名托管期間由甲方負責續費。</p>
      <p>
        <b>四、免責條款</b>
      </p>
      <p>1、甲、乙雙方確認托管的質押域名無任何爭議，不會讓丙方承擔任何責任。</p>
      <p>
        2、甲方應當將域名續費至足夠長的時間防止域名到期，若域名在托管期間內到期，由甲方自行承擔責任。
      </p>
      <p>
        3、甲、乙雙方知悉域名屬於知識產權、無形資產，並了解域名的特殊性，明白處置域名存在的各種風險，因此甲、乙雙方認可丙方通過議價、壹口價、打包價、拍賣方式或其他方式處置域名過程之中的壹切行為並認可處置域名的結果，尤其可能出現處置域名所得的資金不足以償還甲方全部借款的情形，甲乙雙方仍然認可並承諾不會因為域名處置而追究融資界、丙方的任何責任。
      </p>
      <p>
        <b>五、通知與送達</b>
      </p>
      <p>
        1、協議各方因履行本協議而相互發出或者提供的所有通知、文件、資料，均以本協議所列明及在融資界留下的聯系地址、電話、郵箱、微信、QQ等聯系方式進行送達，可由采用專人送達、掛號郵遞、特快專遞或通過融資界發布等方式傳送，壹方如果變更聯系方式，應當書面通知融資界。電子信息或郵件壹經發出，視為送達。
      </p>
      <p>
        <b>六、管轄及法律適用</b>
      </p>
      <p>
        1、本協議的成立、生效、履行、解釋及糾紛解決，適用仲裁機構所在地區法律。
      </p>
      <p>
        2、若用戶和融資界之間發生任何糾紛或爭議無法自行解決的，應向深圳仲裁委員會申請仲裁，仲裁流程及規則以申請時的流程及規則為準。
      </p>
    </div>
  </div>
</template>
<script>
/*
type [int]
1. 风险告知书 融资者
2. 风险告知书 投资者
3. 域名投资协议
4. 用户服务协议
5. 隐私保护协议
6. 域名价值估算声明
*/
export default {
  props: ["type", "agreeData", "personMsg"],
  computed: {
    safe() {
      return this.$store.state.user.safe
    },
  },
}
</script>
<style lang="less" scoped>
.text-right {
  text-align: right;
}
.sj {
  text-indent: 2em;
}
h2 {
  font-size: 18px;
  text-align: center;
  line-height: 30px;
}
h3 {
  font-size: 16px;
  line-height: 30px;
}
p {
  font-size: 14px;
  // line-height: 1.5;
  line-height: 30px;

  // margin: 10px 0;
}
table {
  border: solid 1px #ccc;
  width: 100%;
  border-right: 0;
  border-bottom: 0;
  .domain {
    word-break: break-word;
  }
  td {
    border: solid 1px #ccc;
    border-left: 0;
    border-top: 0;
    // padding: 5px 10px;
    padding: 0 10px;
    height: 29px;
    line-height: 29px;
  }
}
</style>
